import Reveal from '@/components/feature/Reveal';
import { featuredPosts } from '@/mocks/home';

export default function FeaturedGossip() {
  return (
    <section id="campus" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-primary-600 uppercase">
              <i className="ri-fire-line" /> 吃瓜大本营
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
              今日热帖，一篇都别落下
            </h2>
          </div>
          <p className="md:max-w-md text-sm md:text-base leading-relaxed text-foreground-600">
            公共区老哥正在逐帧扒细节、整理对照表、接力跟热评。挑一篇进去，评论区已经有同好在等你了。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredPosts.map((post, index) => (
            <Reveal key={post.id} delay={index * 60}>
              <a
                href="#campus"
                className="group block h-full rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="relative w-full h-48 md:h-52 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    title={`${post.title} - 黑料网社 吃瓜大本营`}
                    className="w-full h-full object-top group-hover:scale-[1.04] transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 h-7 px-3 inline-flex items-center rounded-full bg-primary-500 text-background-50 text-xs font-bold whitespace-nowrap">
                    {post.category}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {post.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-2">{post.excerpt}</p>
                  <div className="mt-5 pt-4 border-t border-background-200 flex items-center gap-4 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                      <i className="ri-user-3-line" /> {post.author}
                    </span>
                    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                      <i className="ri-fire-line text-primary-500" /> {post.heat}
                    </span>
                    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                      <i className="ri-chat-1-line" /> {post.comments}
                    </span>
                    <span className="ml-auto whitespace-nowrap hidden xl:inline">{post.time}</span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}